type Args = Array<string | undefined | null | Record<string, boolean>>;

// mergear classNames
export function cl(...args: Args): string {
  const classes = new Set();
  for (const arg of args) {
    if (!arg) continue;
    if (typeof arg === 'number') continue;
    if (Array.isArray(arg)) continue;
    // strings
    if (typeof arg === 'string') {
      classes.add(arg.trim());
    }
    // check if it's an object
    if (typeof arg === 'object') {
      for (const [key, value] of Object.entries(arg)) {
        if (value === true) {
          classes.add(key.trim());
        }
      }
    }
  }
  return Array.from(classes).join(' ');
}
